module.exports = __webpack_public_path__ + "static/media/anna-franceschi.b726e5a5.jpeg";